import { render, staticRenderFns } from "./v-checkbox.vue?vue&type=template&id=55e5705f&"
import script from "./v-checkbox.vue?vue&type=script&lang=js&"
export * from "./v-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox.vue?vue&type=style&index=0&id=55e5705f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports